export const sentryConfig = {
  dsn: 'https://5e9d09694e5cbcd246a46aa93e111b24@o4510026841784320.ingest.us.sentry.io/4510026855153664',
};
